import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

import { IdentifyMethod } from '@jct/api';
import { isValidIdNumber } from '@jct/core';

export const ID_NUMBER_LENGTH = 9;
export const PASSPORT_MAX_LENGTH = 10;

export function normalizeIdNumber(value: unknown): string {
  return (value || '').toString().replace(/\D/g, '').slice(0, ID_NUMBER_LENGTH);
}

export function idNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || '').toString().trim();

    if (!value) {
      return null;
    }

    return /^\d{9}$/.test(value) && isValidIdNumber(value) ? null : { idNumber: true };
  };
}

export function applyIdentityKeyValidators(control: AbstractControl, method: IdentifyMethod) {
  if (method === IdentifyMethod.IdNumber) {
    control.setValidators([Validators.required, idNumberValidator()]);
  } else {
    control.setValidators([Validators.required, Validators.maxLength(PASSPORT_MAX_LENGTH)]);
  }

  control.updateValueAndValidity({ emitEvent: false });
}
